import { render, staticRenderFns } from "./wxApply.vue?vue&type=template&id=135228b1&"
import script from "./wxApply.vue?vue&type=script&lang=js&"
export * from "./wxApply.vue?vue&type=script&lang=js&"
import style0 from "./wxApply.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports